import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const templateApis   = createApi({
    reducerPath: 'templateApis',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['template'],
    endpoints: (builder) => ({

        templateRender: builder.query({
            query: () => ({
                url: `/api/template-settings/render-template`,
                method: 'GET',
                responseHandler: (response) => response.text(),
            }),
            transformResponse: (response) => {
                console.log("API Response:", response);
                try {
                    const jsonResponse = JSON.parse(response);
                    console.log("Parsed JSON Response:", jsonResponse);
                    return jsonResponse;
                } catch (error) {
                    console.error("Invalid JSON response:", response);
                    throw new Error("Invalid response from server");
                }
            },
            // providesTags: ['Template'],
        }),

        getTemplate: builder.query({
            query: (data) => ({
                url: `/api/template-settings/get-template`,
                method: 'GET',
                body: data,
            }),
            // Tagged so that saving the website (createTemplate) invalidates this
            // and the saved settings are refetched. Without it the masjid-web page
            // kept serving a stale cached copy after a save.
            providesTags: ['template'],
        }),

        createTemplate: builder.mutation({
            query: (data) => ({
                url: `/api/template-settings/cu-template`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['template'],
        }),

        // Website editor. Autosave writes the draft only; publish copies it to
        // the live site. Neither should refetch the site mid-edit, so they
        // don't invalidate the template cache (publish does, once).
        saveDraft: builder.mutation({
            query: (data) => ({
                url: `/api/template-settings/draft`,
                method: 'PUT',
                body: data,
            }),
        }),

        publishSite: builder.mutation({
            query: () => ({
                url: `/api/template-settings/publish`,
                method: 'POST',
            }),
            invalidatesTags: ['template'],
        }),

        discardDraft: builder.mutation({
            query: () => ({
                url: `/api/template-settings/draft`,
                method: 'DELETE',
            }),
            invalidatesTags: ['template'],
        }),

        checkUrl: builder.query({
            query: ({urlpath}) => ({
                url: `/api/template-settings/check-available-url-path?urlpath=${urlpath}`,
                method: 'GET',
            }),
            providesTags: ['template'],
        }),
    }),
});

export const {
    useTemplateRenderQuery,
    useCreateTemplateMutation,
   useGetTemplateQuery,
   useCheckUrlQuery,
   useSaveDraftMutation,
   usePublishSiteMutation,
   useDiscardDraftMutation
} = templateApis;